<div class="container">
    <div class="row product-row">
        <div class="col-lg col-12 product-col">
            <div class="product-box">
                <div class="product-details">
                    <div class="gallery">
                        <div class="gallery-container">
                            <!-- imageRatio='ratio-16by9' -->
                            <app-product-gallery-new [productLayout]="layout" [images]="product?.images">
                            </app-product-gallery-new>
                        </div>
                    </div>
                    <div class="details">
                        <p class="font-weight-bold" *ngIf="product?.categoryData">
                            {{translateHelper.localize(product.categoryData[0]?.name)}}</p>
                        <h1 class="product-name">{{ translateHelper.localize(product.name) }}</h1>
                        <p *ngIf="product.code">
                            <small>{{"item_code"|translate}}: <b>{{product.code}}</b></small>
                        </p>

                        <!-- <p class="availability">
                            {{"availability"|translate}}:
                            <b *ngIf="product.quantity?.amount > 0" class="text-success">{{"in_stock"|translate}}</b>
                            <b *ngIf="product.quantity?.amount <= 0" class="text-danger">{{"out_of_stock"|translate}}</b>
                        </p> -->

                        <div *ngIf="product && !bookingMode && (product.pricePerHour ||  product.pricePerDay || product.price)" class="prices">
                            <ng-container *ngIf="!product.hidePrice && !product.timeType">
                                {{ product.price|currencyFormat }}
                            </ng-container>
                            <ng-container *ngIf="product.timeType == 'time_slots'">
                                {{ product.price|currencyFormat}}<span class="price-comment">{{"per_slot_suffix"|translate}}</span>
                            </ng-container>
                            <ng-container *ngIf="product.timeType == 'no_time'">
                                {{ product.pricePerDay|currencyFormat}}<span class="price-comment">{{"per_day_suffix"|translate}}</span>
                            </ng-container>
                            <ng-container *ngIf="product.timeType == 'time_range'">
                                {{ product.pricePerHour|currencyFormat}}<span class="price-comment">{{"per_hour_suffix"|translate}}</span>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="bookingMode">
                            <div class="prices">
                                {{ (product.taxedPrice || product.price)|currencyFormat }}<span class="price-comment">{{
                                    (product.timeType == 'time_slots' ? 'per_slot_suffix'
                                        : product.priceMode == 'per_booking' ? 'per_booking_suffix' : 'per_day_suffix')|translate }}</span>
                            </div>
                            <ul class="booking-facts">
                                <li *ngIf="product.hours">
                                    <mat-icon>schedule</mat-icon>
                                    <span>{{"service_duration"|translate}}: {{"hours_value"|translate: { hours: product.hours } }}</span>
                                </li>
                                <li>
                                    <mat-icon>event</mat-icon>
                                    <span>{{"booking_type"|translate}}: {{ ('booking_type_' + product.dateType)|translate }}
                                        &middot; {{ ('booking_time_' + product.timeType)|translate }}</span>
                                </li>
                            </ul>
                        </ng-container>
                        <div *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                            <small class="font-weight-bold">{{"inclusive"|translate}}</small>
                        </div>

                        <!-- <div class="mt-3" [innerHTML]="translateHelper.localize(product?.description)"></div> -->

                        <div *ngIf="product.options && !bookingMode">
                            <app-product-options [baseForm]="form" [optionsObject]="product?.options" [product]="product">
                            </app-product-options>
                        </div>

                        <div class="mt-3">
                            <app-social-share-buttons [layout]="'col'"></app-social-share-buttons>
                        </div>

                    </div>
                </div>
                <div class="booking-details">
                    <app-booking-tabs *ngIf="product" [product]="product" [disabledDates]="disabledDates" [serviceData]="serviceData" [timeslots]="timeslots" [form]="form"></app-booking-tabs>
                </div>

                <div>
                    <div class="book-actions" *ngIf="bookingMode">
                        <button type="button" class="btn btn-primary" [ngClass]="{'btn-loading': booking}" [disabled]="booking" (click)="bookService()">
                            <mat-icon>event_available</mat-icon>
                            <span>{{"book_service"|translate}}</span>
                        </button>
                    </div>
                    <div class="quote-actions" *ngIf="!bookingMode" [ngClass]="{'mobile-fab': isMobile}">
                        <app-input-number-new appClick layout="input-4" (addToCart)="addToCart()" aria-label="Quantity" class="product__quantity-availability" [min]="product.quantity?.min" [max]="product.quantity?.max" [step]="product.quantity?.step" [formControl]="form.get('amount')"></app-input-number-new>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-lg-auto col-12 vendor-col">
            <ng-content select="[serviceAside]"></ng-content>
            <div class="bg-card-new card-radius-06" *ngIf="!bookingMode">
                <div class="vendor-box" *ngIf="product.companyData">
                    <div class="vendor-info">
                        <div class="logo">
                            <a [routerLink]="['/vendor', product.companyData?.seo?.slug]">
                                <img *ngIf="product?.companyData?.design" [src]="product.companyData?.design?.logo?.thumb?.url || product.companyData?.design?.logo?.url">
                            </a>
                        </div>
                        <div class="w-full">
                            <a class="vendor-name" [routerLink]="['/vendor', product.companyData?.seo?.slug]">
                                {{translateHelper.localize(product.companyData?.name)}}
                            </a>
                            <div class="desc w-full mt-3">
                                <div>
                                    <ng-scrollbar pointerEventsMethod="scrollbar" appearance="standard" class="c-scroll">
                                        <div [innerHTML]="translateHelper.localize(product?.companyData?.description)">
                                        </div>
                                    </ng-scrollbar>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="controls">
                        <div class="company-controls">
                            <a *ngIf="whatsapp" eventCollector eventName="whatsapp" category="product_page" itemType="product" [companyId]="product.companyData?._id" [productId]="product._id" href="https://api.whatsapp.com/send?phone={{whatsapp?.number}}&text={{whatsapp?.text}}"
                                class="btn green btn-secondary" target="_blank">
                                <div class="icon"><mat-icon inline="true" svgIcon="chat-elipses"></mat-icon></div>
                            </a>
                            <button eventCollector [companyId]="product.companyData?._id" [productId]="product._id" eventName="vendor_chat" (click)="openChat();" category="product_page" itemType="product" class="btn bg-contrast-black rounded-full">
                                <div class="flex flex-row items-center justify-center text-white">
                                    <div class="icon">
                                        <mat-icon svgIcon="chat-info"></mat-icon>
                                    </div>
                                    <div class="label">{{"chat_with_vendor"|translate}}</div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
